import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

// Kept out of `useFinancing` on purpose: that query polls every 15s and `system_type` is
// resolved by the BFF through an extra simulator call. The value is immutable, so it is
// fetched once, and a failure here never affects the main `financingV2` query.
// `financingV2(id)` is looked up by project id (same argument `useFinancing` receives).
export default function useFinancingSystemType(projectId: Ref<string | undefined>) {
  const queryKey = computed(() => queryKeys.FINANCING.SYSTEM_TYPE(projectId.value ?? ''))

  const enabled = computed(() => Boolean(projectId.value))

  const queryFn = async () => {
    const res = await financialBff('query')({
      financingV2: [{ id: projectId.value! }, {
        system_type: true,
      }],
    })

    return res.financingV2?.system_type ?? null
  }

  return useQuery({
    queryFn,
    queryKey,
    enabled,
    staleTime: Infinity,
    retry: false,
  })
}
